"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Scissors: function() {
        return Scissors;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Scissors = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M1 18.9775C1 21.1867 2.79086 22.9775 5 22.9775C7.20914 22.9775 9 21.1867 9 18.9775C9 17.4592 8.15404 16.1385 6.90775 15.4609L10.6363 13.1666L21.4751 19.8511C21.9452 20.1411 22.5612 19.995 22.8512 19.5249C23.1411 19.0548 22.995 18.4388 22.5249 18.1488L12.5435 11.9931L22.5241 5.85168C22.9944 5.56224 23.1411 4.9463 22.8517 4.47593C22.5622 4.00556 21.9463 3.85889 21.4759 4.14832L10.6375 10.8176L6.90707 8.51699C8.15373 7.83956 9 6.51861 9 5C9 2.79086 7.20914 1 5 1C2.79086 1 1 2.79086 1 5C1 6.53138 1.86056 7.86177 3.12448 8.53394L8.73027 11.9912L3.08521 15.4648C1.84277 16.1434 1 17.4621 1 18.9775ZM4.07687 17.2029L3.83497 17.3517C3.32936 17.7147 3 18.3076 3 18.9775C3 20.0821 3.89543 20.9775 5 20.9775C6.10457 20.9775 7 20.0821 7 18.9775C7 17.873 6.10457 16.9775 5 16.9775C4.66702 16.9775 4.35304 17.0589 4.07687 17.2029ZM3.8049 6.60381C3.31633 6.23916 3 5.65652 3 5C3 3.89543 3.89543 3 5 3C6.10457 3 7 3.89543 7 5C7 6.10457 6.10457 7 5 7C4.67883 7 4.37535 6.9243 4.10641 6.78976L3.8049 6.60381Z",
        fill: "currentColor"
    })
}), "Scissors");
const _default = Scissors;
